import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTheme } from '../../../context/ThemeContext.jsx';
import { DOMAIN_TYPES } from '../../config/domainTypes';

export const ThemeRouteSync = ({ domainType }) => {
  const location = useLocation();
  const { setFlexOfficeScopeActive } = useTheme() || {};

  useEffect(() => {
    if (!setFlexOfficeScopeActive) {
      return;
    }

    const path = location.pathname.toLowerCase();
    const isFlexOfficeMarketingPath =
      path.includes('flexoffice')
      || path.includes('cowork')
      || path.includes('about-flexoffice');

    setFlexOfficeScopeActive(
      domainType === DOMAIN_TYPES.FLEX_OFFICE || isFlexOfficeMarketingPath
    );
  }, [domainType, location.pathname, setFlexOfficeScopeActive]);

  return null;
};
